import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Svg from '../modules/Svg';
import Tabs from '../components/tabs/index';
import tabsConfig from '../config/tabsConfigCatalogues';

/**
 * Catalogue header component
 * Renders on upcoming sales, sires, vendors and previously sold lots pages
 */
class SalesCatalogue extends Component {
    /**
     * Initialize component
     * Takes from view data attributes for displaying sale information
     *
     * @param props
     */
    constructor(props) {
        super(props);
        const dataSet = document.getElementById('root').dataset;

        this.totalLots = dataSet.saletotallots;
        this.name = dataSet.salename;
        this.company = dataSet.salecompany;
        this.date = dataSet.saledate;
        this.activeTab = dataSet.activetab;
    }

    /**
     * Renders catalogue header component
     * Header includes sale information, lots counter, back link to catalogue
     * As child element accepts concrete page (table) content
     *
     * @returns {ReactElement}
     */
    render() {
        return (
            <div>
                <section className="sales__tabHeader">
                    <div className="bsp-backLinkWrp">
                        <a
                            href="/bloodstock/sales/catalogues/"
                            className="ui-link ui-link_table bsp-backLink ui-link_marked"
                        >
                            <Svg iconName="left" />
                            <span className="bsp-backLinkText">Back to Sales Catalogues</span>
                        </a>
                    </div>

                    <div className="sales__HeaderWrp">
                        <div className="sales__Header">
                            <h1 className="sales__HeaderName">
                                {this.name}
                            </h1>
                            <span className="sales__HeaderCounter">
                                <span className="sales__Counter">
                                    <span
                                        className="sales__CounterText js-sales-lots-total"
                                        data-test-selector="lots_found_header"
                                    >
                                        {this.totalLots || 0}
                                    </span>
                                </span>
                            </span>
                        </div>
                        <div className="sales__Seller">
                            <span className="sales__SellerDate">
                                Dates: <strong>{this.date}</strong>
                            </span>
                            <span className="sales__SellerCompany">
                                Sale Co: <strong>{this.company}</strong>
                            </span>
                        </div>
                    </div>
                    <Tabs options={tabsConfig} activeTab={this.activeTab} />
                    {this.props.headerContent}
                </section>
                <section className="sales__content">
                    {this.props.children}
                </section>
            </div>
        );
    }
}

SalesCatalogue.propTypes = {
    /**
     * Page content
     * Own prop
     */
    children: PropTypes.object,
    /**
     * Content which should be displayed right after nav tabs
     * Own prop
     */
    headerContent: PropTypes.object,
};

export default SalesCatalogue;



// WEBPACK FOOTER //
// ./src/js/containers/SalesCatalogue.js